module.exports = __webpack_public_path__ + "assets/bd7489a58cc99f2db7b71f757461c2cf.jpg";